import React, { useState } from 'react';
import { componentsSettingIcon, saveInputIcon } from '../../../../../assets/images/icons';
import './FieldRow.scss';
import cls from './FieldRow.module.scss';
import MessageContainer from '../../../../SideMenuEntries/ProcessesComps/MessageContainer/MessageContainer';
import ModalR from '../../Modal/ModalR';
import Spinner from '../../Spinner/Spinner';
import { isMobile } from 'react-device-detect';

const FieldRow = props => {
	const { enabled = '', fieldIcon, mandatory, fieldLabel = '', visible, customIconBgColor, settingsClicked, children, hasSaveInputBtn, hasSettingsBtn, error, border, showWidth = () => { }, dragEnd = () => { }, notes, editMode = false, titleProps = {}, loading = false, landscape = false } = props;
	const [show, setShow] = useState(false);
	return (

		<div
			cid={'field-row-container'}
			id={fieldLabel}
			onClick={() => showWidth(document.getElementById(fieldLabel)?.offsetWidth)}
			onDragEnd={e => {
				dragEnd({
					left: e.clientX,
					top: e.clientY,
				});
			}}
			draggable={editMode}
			style={{
				resize: editMode ? 'both' : '',
				overflow: editMode ? 'auto' : '',
				width: props.width ? props.width : '',
				minWidth: '300px',
				marginBottom: '10px',
				// ...props.style,
				display: visible ? '' : 'none',
				pointerEvents: enabled,
				alignItems: 'center',
				...props?.customStyle ?? {}
			}}
		>
			{(fieldLabel && !landscape) ? (
				<label style={{ ...titleProps, width: landscape ? '160px' : '100%', fontSize: '14px' }}>
					{fieldLabel} {mandatory && <span>*</span>}
				</label>
			) : (
				<></>
			)}


			<div className={editMode ? cls.fieldrow : 'field-row'} app-variant-has-error={error ? 'error' : ''} style={{ ...props.style, width: '100%', marginTop: '10px' }}>

				{(fieldLabel && landscape) && (
					<label style={{ fontWeight: 'normal', fontSize: '15px', ...titleProps, width: '200px' }}>
						{fieldLabel} {mandatory && <span>*</span>}
					</label>
				)}

				<div className={editMode ? cls.fieldrowcontainer : 'field-row-container'} >
					{children}
				</div>



			</div>
			{notes && <p style={{ color: 'black', fontSize: '14px', fontWeight: 'normal', marginTop: '10px', marginBottom: '40px', paddingLeft: landscape ? '150px' : '5px', width: 'auto', textAlign: isMobile ? 'center':'left' }}>
				{notes}
			</p>}
			{error && <MessageContainer message={error} />}
			{loading && show ? (
				<ModalR blured={true} scrollable={true} isOpen={loading && show} shadowedContainerStyle={{ width: '200px' }}>
					<div className={cls.center} style={{ width: '200px', height: '50px' }} onClick={() => setShow(false)}>
						<Spinner type={'BallTriangle'} color="black" height={30} width={`30px`} style={{ marginRight: '30px' }} />
						{'Processing...'}
					</div>
				</ModalR>
			) : null}
		</div>


	);
};

export default FieldRow;


export const FieldRowV2 = props => {
	const { enabled = '', fieldIcon, mandatory, fieldLabel = '', visible, customIconBgColor, settingsClicked, children, hasSaveInputBtn, hasSettingsBtn, error, border, showWidth = () => { }, dragEnd = () => { }, notes, editMode = false, titleProps = {}, loading = false, landscape = false } = props;
	const [show, setShow] = useState(false);
	return (
		<>
			<div
				cid={'field-row-container'}
				id={fieldLabel}
				onClick={() => showWidth(document.getElementById(fieldLabel)?.offsetWidth)}
				onDragEnd={e => {
					dragEnd({
						left: e.clientX,
						top: e.clientY,
					});
				}}
				draggable={editMode}
				style={{
					resize: editMode ? 'both' : '',
					overflow: editMode ? 'auto' : '',
					width: props.width ? props.width : '',
					minWidth: '300px',
					...props.style,
					display: visible ? landscape ? 'flex' : '' : 'none',
					pointerEvents: enabled,
					alignItems: 'center',
					backgroundColor: 'var(--app-color-gray-lightest)',
					// padding: isMobile? '5px':'10px 20px',
					// margin: isMobile ? '5px':'10px'
					padding: '5px',
					margin: '5px'
				}}
			>
				{fieldLabel ?
					<label style={{ fontWeight: 'normal', fontSize: '14px', ...titleProps, width: landscape ? '160px' : '100%' }}>
						{fieldLabel} {mandatory && <span>*</span>}
					</label>
					:
					<></>
				}
				<div className={editMode ? cls.fieldrow : 'field-row'} app-variant-has-error={error ? 'error' : ''} style={{ width: landscape ? '70%' : '100%' }}>
					<div className={editMode ? cls.fieldrowcontainer : 'field-row-container'}>
						{children}
					</div>

				</div>

			</div>

		</>
	);
};
